import axios from "./plugins/axios.js";
window.axios = axios;

import moment from "moment";
window.moment = moment;

import lodash from "lodash";
window._ = lodash;

import Vue from "vue";

// Enable Vue DevTools when VITE_ENABLE_DEVTOOLS=true
Vue.config.devtools = typeof __VUE_ENABLE_DEVTOOLS__ !== "undefined" && __VUE_ENABLE_DEVTOOLS__;
Vue.config.productionTip = false;

import i18n from "./i18n";
import "moment/locale/en-gb";
// import "moment/locale/ru";

window.__ = (trans, opts) => i18n.t(trans, opts);
window.Bus = new Vue();

moment.defineLocale("en-short", {
  parentLocale: "en",
  relativeTime: {
    future: "in %s",
    past: "%s ago",
    s: "1s",
    m: "1m",
    mm: "%dm",
    h: "1h",
    hh: "%dh",
    d: "1d",
    dd: "%dd",
    M: "1 month",
    MM: "%d months",
    y: "1y",
    yy: "%dy",
  },
});

moment.locale("en");

import VueRouter from "vue-router";
Vue.use(VueRouter);

import VueMeta from "vue-meta";
Vue.use(VueMeta);

import VTooltip from "v-tooltip";
Vue.use(VTooltip);

import LoadScript from "vue-plugin-load-script";
Vue.use(LoadScript);

import SparkPlugin from "./plugins/spark";
Vue.use(SparkPlugin);

import buildURLPlugin from "./plugins/build-url";
Vue.use(buildURLPlugin);

import VueModal from "vue-js-modal";
Vue.use(VueModal, { dynamic: true, injectModalsContainer: true });

import VueNotification from "vue-notification";
Vue.use(VueNotification);

import VueCookies from "vue-cookies";
Vue.use(VueCookies);

import("./components/index.js");
import("../../spark/resources/assets/js/forms/bootstrap.js");
